/**
 * Configuration du branding multi-domaine.
 *
 * Les domaines Syn'APPs utilisent la même application, la même API et la même
 * base de données que Qualifop ; seul le branding dépend du hostname.
 */
export const brandingConfig = {
  'pwa.local.gd': {
    name: 'Qualifop',
    title: null,
    tagline: null,
    logoPath: require('@/assets/images/qualifopLogo-Q.svg'),
    primaryColor: '#7EB8A3',
    isLightMode: false
  },

  'synappssolution.local.gd': {
    name: "Syn'APPs Solution",
    title: "Syn'APPs® Solution",
    tagline: 'Piloter et tracer les parcours administratifs et pédagogiques des structures APP, en centre, en alternance et en multi-financement.',
    logoPath: require('@/assets/images/app-logo.png'),
    primaryColor: '#35505B',
    isLightMode: false
  },

  'synapps-solution.fr': {
    name: "Syn'APPs Solution",
    title: "Syn'APPs® Solution",
    tagline: 'Piloter et tracer les parcours administratifs et pédagogiques des structures APP, en centre, en alternance et en multi-financement.',
    logoPath: require('@/assets/images/app-logo.png'),
    primaryColor: '#35505B',
    isLightMode: false
  },

  'synappsparcours.local.gd': {
    name: "Syn'APPs Parcours",
    title: "Syn'APPs® Parcours",
    tagline: 'Piloter, tracer et accompagner les parcours pédagogiques des publics en APP, y compris en alternance.',
    logoPath: require('@/assets/images/app-logo.png'),
    primaryColor: '#35505B',
    isLightMode: true
  }
}

export const defaultBranding = brandingConfig['pwa.local.gd']

export function getBrandingByHostname(hostname) {
  return brandingConfig[hostname] || defaultBranding
}

export function isSynappsHostname(hostname) {
  return hostname === 'synappssolution.local.gd' ||
    hostname === 'synapps-solution.fr' ||
    hostname === 'synappsparcours.local.gd'
}
